import React from "react";
import { Modal } from "antd";
import { useTranslation } from "react-i18next";

const VerifiedAgencyInfoModal = ({ isVisible, hide, message = null }) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t("Limited functionality")}
      visible={isVisible}
      onOk={hide}
      onCancel={hide}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <div style={{ margin: "24px" }}>
        {message ? <p>{message}</p> : null}
        <p>
          {t("Verified agencies text")}{" "}
          <a
            href="https://help.latinad.com/faq-agencias/#hfaq-post-4111"
            target="_blank"
            rel="noopener noreferrer"
          >
            help.latinad.com
          </a>
        </p>
      </div>
    </Modal>
  );
};

export default VerifiedAgencyInfoModal;
